<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :meun="meunItem" :title="meunTitle" :title2="headTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <h3 class="title">{{ headTitle }}</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <div class="input_div">
                <p>校友会名称</p>
                <el-input class="input" v-model="info.title" placeholder="请输入"></el-input>
              </div>
              <!-- <div class="input_div">
                <p>校友会英文简称</p>
                <el-input
                  class="input"
                  v-model="info.title_en"
                  placeholder="请输入"
                ></el-input>
              </div> -->
              <div class="input_div">
                <p>联系人名称</p>
                <el-input class="input" v-model="info.administrator" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>联系人微信</p>
                <el-input class="input" v-model="info.admin_wechat" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>校友会公众号</p>
                <el-input class="input" v-model="info.wechat" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>分会状态</p>
                <el-select class="input" v-model="info.status" placeholder="请选择" collapse-tags>
                  <el-option v-for="item in pushOptions" :key="item.en" :value="item.en" :label="item.cn"></el-option>
                </el-select>
              </div>
              <div class="input_div" v-if="isAssociationAdmin == 'N'">
                <p>分会管理员</p>
                <el-select class="input" v-model="info.admin_id" placeholder="请选择" collapse-tags clearable>
                  <el-option v-for="item in adminOptions" :key="item.id + ''" :value="item.id + ''" :label="item.name"></el-option>
                </el-select>
              </div>
              <div class="input_div">
                <p>社群类型</p>
                <el-select class="input" v-model="info.type" placeholder="请选择" clearable>
                  <el-option v-for="item in info.association_type" :key="item" :value="item" :label="item"></el-option>
                </el-select>
              </div>
              <div class="input_div">
                <p>后台分类</p>
                <el-select class="input" v-model="info.b_type" placeholder="请选择" clearable>
                  <el-option v-for="item in bTypeOptions" :key="item" :value="item" :label="item"></el-option>
                </el-select>
              </div>
              <div style="clear: both"></div>
              <div class="input_div">
                <p>校友会logo</p>
                <input type="file" accept="image/*" style="display: none" id="uploadfile" @change="openFolder" />
                <el-button size="mini" @click="openImage()">选择本地图片</el-button>
                <el-image class="imageDiv" :src="imageUrl" fit="scale-down">
                  <div slot="error" class="image-slot" style="position: absolute; top: 50%; left: 50%">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div style="clear: both"></div>
              <div class="input_div" style="width: 100%">
                <p>校友会简介</p>
                <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="info.abstract"> </el-input>
              </div>
            </div>
          </div>
          <!-- <div class="footSubmit">
            <el-button
              style="float: right; margin-right: 30px"
              size="small"
              type="primary"
              @click="saveEdit()"
              >提交</el-button
            >
            <el-button
              style="float: right; margin-right: 15px"
              size="small"
              @click="toCancel()"
              >取消</el-button
            >
          </div> -->
          <FootLayout v-on:saveEdit="saveEdit"></FootLayout>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'
import FootLayout from '@/components/layout/footLayout'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    FootLayout
  },
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      headTitle: '',
      urlPath: URL_PATH,
      info: {},
      pushOptions: [
        { cn: '已发布', en: 'Y' },
        { cn: '未发布', en: 'N' }
      ], //是否发布
      imageUrl: '',
      isAssociationAdmin: 'Y',
      adminOptions: [],
      bTypeOptions: [] // 后台分类选项
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.infoId = this.$route.query.id
      this.headTitle = this.infoId == null ? '新增校友会' : '编辑校友会'
      this.associationAdmin()
      this.getAssociationAdminList()
      this.getBTypeOptions() // 获取后台分类选项
      this.getInfo()
    },
    // 获取后台分类选项
    getBTypeOptions() {
      this.$api
        .associationList({
          token: localStorage.getItem('token'),
          page: 1,
          limit: 1
        })
        .then(({ data }) => {
          this.bTypeOptions = data.Data.bType || []
          // 同时获取社群类型选项（如果详情接口有返回的话）
          if (!this.infoId && data.Data.type) {
            this.info.association_type = data.Data.type
          }
        })
        .catch(({ error }) => {})
    },
    // 是否是校友分会长
    associationAdmin: function () {
      this.$api
        .isAssociationAdmin({
          token: localStorage.getItem('token')
        })
        .then(({ data }) => {
          this.isAssociationAdmin = data.Data.isAssociationAdmin
        })
        .catch(({ error }) => {})
    },
    // 获取分会长管理员列表
    getAssociationAdminList() {
      this.$api
        .getAssociationAdminList({
          token: localStorage.getItem('token')
        })
        .then(({ data }) => {
          this.adminOptions = data.Data
        })
        .catch(({ error }) => {})
    },
    // 获取详情
    getInfo() {
      var id = this.$route.query.id
      if (id == null) return
      this.$api
        .associationInfo({
          token: localStorage.getItem('token'),
          id: id
        })
        .then(({ data }) => {
          this.info = data.Data
          this.createTime = new Date(this.info.create_time * 1000)
          this.imageUrl = this.urlPath + this.info.thumb
          // 如果是编辑模式且有 bType 数据，使用接口返回的 bType
          if (data.Data.bType && data.Data.bType.length > 0) {
            this.bTypeOptions = data.Data.bType
          }
          // 如果有社群类型数据，使用接口返回的 association_type
          if (data.Data.association_type && data.Data.association_type.length > 0) {
            this.info.association_type = data.Data.association_type
          }
        })
        .catch(({ error }) => {})
    },
    // 新增
    addInfo: function (form) {
      this.$api
        .updateAssociation(form)
        .then(({ data }) => {
          this.$router.back(-1)
        })
        .catch(({ error }) => {})
    },
    // 编辑
    updateInfo: function (form) {
      form.append('id', this.info.id)
      this.$api
        .updateAssociation(form)
        .then(({ data }) => {
          this.$router.back(-1)
        })
        .catch(({ error }) => {})
    },
    // 选择图片
    openImage() {
      document.getElementById('uploadfile').click()
    },
    openFolder(e) {
      var that = this
      var image = e.target.files[0]
      var reader = new FileReader()
      reader.onload = function (evt) {
        that.imageUrl = evt.target.result
      }
      reader.readAsDataURL(image)
      this.info.thumb = image
    },
    // 保存
    saveEdit() {
      if (
        StrUtils.isEmpty(this.info.title) ||
        // StrUtils.isEmpty(this.info.title_en) ||
        StrUtils.isEmpty(this.info.administrator) ||
        StrUtils.isEmpty(this.info.admin_wechat) ||
        StrUtils.isEmpty(this.info.wechat) ||
        StrUtils.isEmpty(this.info.status) ||
        StrUtils.isEmpty(this.info.abstract) ||
        StrUtils.isEmpty(this.info.thumb)
      ) {
        this.$message.error('请先完善数据')
        return
      }
      var form = new FormData()
      form.append('token', localStorage.getItem('token'))
      form.append('title', this.info.title)
      // form.append("title_en", this.info.title_en);
      form.append('administrator', this.info.administrator)
      form.append('admin_wechat', this.info.admin_wechat)
      form.append('wechat', this.info.wechat)
      form.append('abstract', this.info.abstract)
      form.append('status', this.info.status)
      form.append('image', this.info.thumb)
      form.append('type', this.info.type)
      form.append('b_type', this.info.b_type)
      if (this.isAssociationAdmin == 'N') {
        form.append('admin_id', this.info.admin_id)
      }
      if (this.infoId) {
        this.updateInfo(form)
      } else {
        this.addInfo(form)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-top: 24px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.operateText {
  font-size: 14px;
}

.input_div {
  width: 290px;
  margin-right: 120px;
  margin-bottom: 32px;
  float: left;
}
.input_div .input {
  width: 100%;
}
.input_div p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-bottom: 8px;
}
</style>

 <style lang="less">
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type='number'] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/associationAdd.vue